import { render, staticRenderFns } from "./ServiceBagde.vue?vue&type=template&id=38477003&scoped=true&"
import script from "./ServiceBagde.vue?vue&type=script&lang=js&"
export * from "./ServiceBagde.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBagde.vue?vue&type=style&index=0&id=38477003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38477003",
  null
  
)

export default component.exports